<template>
  <div id="setting-score">
    <b-row
      class="card-setting-score font-medium-5 text-black font-weight-bolder"
    >
      <b-col cols="6">
        <div class="d-flex align-item-center">
          <b-form-checkbox
            v-model="scoreData.isSetScore"
            class="mr-0 custom-control-success mr-4"
            name="is-rtl"
            :value="true"
            switch
            inline
            :disabled="!scoreData.isEdit"
          />
          <div class="mt-5px ml-4">กำหนดคะแนน และแสดงผลลัพธ์</div>
        </div>
      </b-col>
      <b-col cols="6" v-if="scoreData.isSetScore">
        <div class="d-flex align-item-center justify-content-end">
          <div class="mr-4">Total Score</div>
          <div class="total-score-wrp">
            <div>{{ scoreData.totalScore }}</div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row
      class="setting-point-wrp mt-1 text-black"
      v-if="scoreData.isSetScore"
    >
      <b-col cols="12">
        <b-card no-body class="container-wrp mb-1 mt-2">
          <b-row class="mt-2">
            <b-col>
              <div
                class="d-flex justify-content-between mb-1"
                v-for="(question, idx) in scoreData.questionList"
                :key="idx"
              >
                <div class="w-100 bg-hover padding-wrp">
                  <div class="font-name-question">{{ question.name }}</div>
                  <div
                    v-for="(choice, index) in question.choiceList"
                    :key="index"
                    class="d-flex justify-content-between align-item-center mt-2 mb-2"
                  >
                    <div class="w-70">
                      <div
                        class="radio-type pl-2 d-flex"
                        v-if="question.formatType == SCORETYPE.TYPE.SINGLE"
                      >
                        <b-form-radio
                          v-model="choice.name"
                          value="1"
                          class="bypass"
                          :class="
                            choice.other &&
                            question.type == SCORETYPE.FORMAT.IMAGE
                              ? 'mt-3'
                              : ''
                          "
                          disabled
                        >
                          <div class="text-black font-medium-5">
                            <div v-if="question.type == SCORETYPE.FORMAT.TEXT">
                              <div v-if="!choice.other">
                                <div>{{ choice.name }}</div>
                                <div v-if="!choice.name" class="none-text">
                                  Answer name
                                </div>
                              </div>
                              <div v-else>
                                <div>
                                  <b-form-input
                                    v-if="choice.other"
                                    class="input-container disabled bypass"
                                    placeholder="Answer name"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              class="image-display-wrp"
                              v-if="question.type == SCORETYPE.FORMAT.IMAGE"
                            >
                              <div
                                v-if="choice.image && !choice.other"
                                class="image-display"
                                :style="{
                                  'background-image': `url(${choice.image})`,
                                }"
                              ></div>
                              <div
                                v-else-if="!choice.image && !choice.other"
                                class="image-display-no-image"
                                :style="{
                                  'background-image': `url(${NoImageIcon})`,
                                }"
                              ></div>
                              <div v-else>
                                <div>
                                  <b-form-input
                                    v-if="choice.other"
                                    class="input-container disabled bypass w-190px"
                                    placeholder="Answer name"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="question.type == SCORETYPE.FORMAT.TEXTIMAGE"
                            >
                              <div v-if="!choice.other">
                                <div>
                                  <div>{{ choice.name }}</div>
                                  <div v-if="!choice.name" class="none-text">
                                    Answer name
                                  </div>
                                </div>
                                <div
                                  class="image-display-wrp"
                                  v-if="choice.image"
                                >
                                  <div
                                    class="image-display"
                                    :style="{
                                      'background-image': `url(${choice.image})`,
                                    }"
                                  ></div>
                                </div>
                                <div
                                  v-else
                                  class="image-display-no-image"
                                  :style="{
                                    'background-image': `url(${NoImageIcon})`,
                                  }"
                                ></div>
                              </div>
                              <div v-else>
                                <div>
                                  <b-form-input
                                    v-if="choice.other"
                                    class="input-container disabled bypass"
                                    placeholder="Answer name"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-form-radio>
                      </div>
                      <div
                        class="checkbox-type pl-2"
                        v-if="question.formatType == SCORETYPE.TYPE.MULTIPLE"
                      >
                        <b-form-checkbox
                          v-model="choice.name"
                          class="bypass"
                          :class="
                            choice.other &&
                            question.type == SCORETYPE.FORMAT.IMAGE
                              ? 'mt-3'
                              : ''
                          "
                          disabled
                        >
                          <div class="text-black font-medium-5">
                            <div v-if="question.type == SCORETYPE.FORMAT.TEXT">
                              <div v-if="!choice.other">
                                <div>{{ choice.name }}</div>
                                <div v-if="!choice.name" class="none-text">
                                  Answer name
                                </div>
                              </div>
                              <div v-else>
                                <div>
                                  <b-form-input
                                    v-if="choice.other"
                                    class="input-container disabled bypass"
                                    placeholder="Answer name"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              class="image-display-wrp"
                              v-if="question.type == SCORETYPE.FORMAT.IMAGE"
                            >
                              <div
                                v-if="choice.image && !choice.other"
                                class="image-display"
                                :style="{
                                  'background-image': `url(${choice.image})`,
                                }"
                              ></div>
                              <div
                                v-else-if="!choice.image && !choice.other"
                                class="image-display-no-image"
                                :style="{
                                  'background-image': `url(${NoImageIcon})`,
                                }"
                              ></div>
                              <div v-else>
                                <div>
                                  <b-form-input
                                    v-if="choice.other"
                                    class="input-container disabled bypass w-190px"
                                    placeholder="Answer name"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="question.type == SCORETYPE.FORMAT.TEXTIMAGE"
                            >
                              <div v-if="!choice.other">
                                <div>{{ choice.name }}</div>
                                <div v-if="!choice.name" class="none-text">
                                  Answer name
                                </div>
                              </div>
                              <div
                                class="image-display-wrp"
                                v-if="choice.image && !choice.other"
                              >
                                <div
                                  class="image-display"
                                  :style="{
                                    'background-image': `url(${choice.image})`,
                                  }"
                                ></div>
                              </div>
                              <div
                                v-else-if="!choice.image && !choice.other"
                                class="image-display-no-image"
                                :style="{
                                  'background-image': `url(${NoImageIcon})`,
                                }"
                              ></div>
                              <div v-else>
                                <div>
                                  <b-form-input
                                    v-if="choice.other"
                                    class="input-container disabled bypass"
                                    placeholder="Answer name"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-form-checkbox>
                      </div>
                      <div
                        class="input-type pl-0"
                        v-if="question.formatType == SCORETYPE.TYPE.TEXTAREA"
                      >
                        <b-form-input
                          disabled
                          class="w-100"
                          placeholder="Answer name"
                        />
                      </div>
                      <div
                        class="date-type pl-2"
                        v-if="question.formatType == SCORETYPE.TYPE.DATE"
                      >
                        <div class="d-flex align-item-center date-wrp">
                          <div class="mr-2">
                            <icon-date class="icon-date" />
                          </div>
                          <div class="font-medium-4">DD-MM-YYYY</div>
                        </div>
                      </div>
                      <div
                        class="dropdown-type pl-2 align-item-center"
                        v-if="question.formatType == SCORETYPE.TYPE.DROPDOWN"
                      >
                        <div class="d-flex">
                          <div class="mr-1 font-medium-5">{{ index + 1 }}.</div>
                          <div class="font-medium-5">
                            <div v-if="!choice.other">
                              <div>{{ choice.name }}</div>
                              <div v-if="!choice.name" class="none-text">
                                Answer name
                              </div>
                            </div>
                            <div v-else>
                              <div>
                                <b-form-input
                                  v-if="choice.other"
                                  class="input-container disabled bypass"
                                  placeholder="Answer name"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <input-spin-quiz
                        :isDisabled="!scoreData.isEdit"
                        :numValue="choice.score"
                        :isText="'คะแนน'"
                        :isInputDisabled="false"
                        @update-number="onUpdateScore($event, choice)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  onBeforeMount,
  watch,
  computed,
  getCurrentInstance,
} from "@vue/composition-api";
import InputSpinQuiz from "@/views/components/input-spin/InputSpinQuiz.vue";
import IconDate from "@/@core/components/svg/common/IconDate.vue";
import NoImageIcon from "@/assets/images/icons/nopicture.png";
export default {
  components: { InputSpinQuiz, IconDate },
  props: { scoreData: { type: Object, default: {} } },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const onUpdateScore = (score, choice) => {
      vm.$emit("onUpdateScore", score, choice);
    };

    const SCORETYPE = {
      TYPE: {
        SINGLE: 1,
        MULTIPLE: 2,
        TEXTAREA: 3,
        DATE: 4,
        DROPDOWN: 5,
      },
      FORMAT: {
        TEXT: 1,
        IMAGE: 2,
        TEXTIMAGE: 3,
      },
    };

    return {
      onUpdateScore,
      NoImageIcon,
      SCORETYPE,
    };
  },
};
</script>

<style  scoped>
@import "~@/assets/css/pages/survey/score.css";
</style>